<template>
	<div id="" ref="" style="">
		<popwin style="width:100%; height:100%;" :ctrl="ctrlWin"></popwin>

		<div style="float:left; height:50px; width:100%; border:0px solid red;">
			<div style="float:left; margin-top:10px; margin-left:10px; display:flex; align-items:center;">
				<radio ref="idOSAn" style="height:30px; margin-right:20px;" v-model="curVer.avOs" :size="18" :root="{obj:this}" :grpName="'GrpOS'" :val="'Android'" :capt="'Android'" :myClick="onAndroidClick"></radio>
				<radio ref="idOSWs" style="height:30px; margin-right:20px;" v-model="curVer.avOs" :size="18" :root="{obj:this}" :grpName="'GrpOS'" :val="'Windows'" :capt="'Windows'" :myClick="onWindowsClick"></radio>
			</div>
		</div>
		<div style="float:left; height:50px; width:100%; border:0px solid red;">
			<div class="SiftPanel" style="">
				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">应用</div>
				<cselect style="position:relative; height:30px; min-width:200px; z-index:999;" :key="appKey" :defv="curVer.avAppId" v-model="curVer.avAppId" :ctrl="ctrlApp" :csData="dataApp" :onchange="onAppChange"></cselect>

				<div style="float:left; margin-top:0px; padding-left:10px; padding-right:10px; height:32px; line-height:32px; margin-left:20px; border-radius:5px; border:1px solid blue; cursor:pointer;" @click="onNewFormShow">添加版本</div>
			</div>
		</div>

		<table class="CFTable" style="float:left; width:98%; margin-left:10px; margin-top:10px;" ref="idVerList"></table>
	</div>
</template>

<script>

import popwin     from '../cf/popwin'
import radio      from '../cf/cradio'
import cselect    from '../cf/cselect'

export default {
	name: 'verMgr',
	components:{
		popwin, radio, cselect
	},
	data () {
		return {
			curVer:{ avAppId:301, avOs:"Android", avId:null, appVerno:"", avPublishDate:"", avPath:"", avForce:0 },
			appList:[],

			ctrlWin:{                               // 弹出窗口控制属性
				w2: 600,
				h2: 320,
				captHeight: 40,                     // 标题栏高度
				captCont: "",                       // 标题
				vuepath: "/FrameBody/verMgr/verNew",
				rcallFunc: this.getVerList,                 // 指定关闭弹出窗后需要执行的回调方法
			},

			ctrlApp:{
				itemHeight: 26,
				bgClr: "#ffffff",
				bodr: "#cccccc",
				expandEmp: false,
				size: 10
			},
			androidApps:[
				{ itemName:"Funsbooth",    itemValue:"301", subItems:[] },
				{ itemName:"AIFuns",       itemValue:"302", subItems:[] },
				{ itemName:"HFuns",        itemValue:"303", subItems:[] }
			],
			windowsApps:[
				{ itemName:"WFunsbooth",   itemValue:"401", subItems:[] }
			],
			appKey: 2000,
			dataApp: []
		}
	},
	mounted: function(){
		this.$refs["idOSAn"].setChecked( true );

		this.dataApp = this.androidApps;
		this.appKey++;

		this.getVerList( 1 );
	},
	computed:{

	},
	methods:{
		onNewFormShow: function(){
			this.ctrlWin.captCont = "添加版本";
			this.ctrlWin.info={ curVer: this.curVer };
			this.ctrlWin.self.onShow();
		},
		onAppChange: function( v1, v2 ){
			let body={ appId: this.curVer.avAppId };
			this.doTrade( "POST", ServAddr+"/api/app/verList", this.getVerListOK, true, body, null );
		},
		onAndroidClick: function(){
			this.curVer.avAppId = 301;
			this.curVer.avOs=="Android";
			this.dataApp = this.androidApps;
			this.appKey++;
			this.getVerList( 3 );
		},
		onWindowsClick: function(){
			this.curVer.avAppId = 401;
			this.curVer.avOs=="Windows";
			this.dataApp = this.windowsApps;
			this.appKey++;
			this.getVerList( 4 );
		},
		getVerList: function( v ){
			console.log( "v=="+v );
			let body={ appId: this.curVer.avAppId };
			this.doTrade( "POST", ServAddr+"/api/app/verList", this.getVerListOK, true, body, null );
		},
		getVerListOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}
			this.appList = data.body.verList;

			this.onShowVerList();
		},
		onShowVerList: function(){
			let obj=this.$refs["idVerList"];
			obj.innerHTML = "";
			let tr=null;
			let td=null;
			tr = document.createElement("tr");
			obj.appendChild( tr );
			td = document.createElement("th");  tr.appendChild(td);   td.innerText = "系统";
			td = document.createElement("th");  tr.appendChild(td);   td.innerText = "应用ID";
			td = document.createElement("th");  tr.appendChild(td);   td.innerText = "应用";
			td = document.createElement("th");  tr.appendChild(td);   td.innerText = "版本ID";
			td = document.createElement("th");  tr.appendChild(td);   td.innerText = "版本";
			td = document.createElement("th");  tr.appendChild(td);   td.innerText = "发布时间";
			td = document.createElement("th");  tr.appendChild(td);   td.innerText = "强制";
			td = document.createElement("th");  tr.appendChild(td);   td.innerText = "文件";
			td = document.createElement("th");  tr.appendChild(td);   td.innerText = "操作";

			for( let i=0; i<this.appList.length; i++ )
			{
				let ver=this.appList[i];
				if( ver.appId != this.curVer.avAppId ) continue;

				let avPath=ver.avPath.split("/");
				tr = document.createElement("tr");
				obj.appendChild( tr );
				td = document.createElement("td");  tr.appendChild(td);   td.innerText = "Android";
				td = document.createElement("td");  tr.appendChild(td);   td.innerText = ver.appId;
				td = document.createElement("td");  tr.appendChild(td);   td.innerText = ver.appName;
				td = document.createElement("td");  tr.appendChild(td);   td.innerText = ver.avId;
				td = document.createElement("td");  tr.appendChild(td);   td.innerText = ver.appVerno;
				td = document.createElement("td");  tr.appendChild(td);   td.innerText = ver.avPublishDate;
				td = document.createElement("td");  tr.appendChild(td);   td.innerText = this.getForceText(ver.avForce);
				td = document.createElement("td");  tr.appendChild(td);   td.innerText = avPath[avPath.length-1];
				td.onclick=function(){
					window.location.href = ver.avPath;
				};
				td.style["color"] = "#2a83cf";
				td.style["cursor"] = "pointer";

				td = document.createElement("td");  tr.appendChild(td);
				td.innerHTML = "[ <font class='OPItem'>"+"删除"+"</font> ]";
				let that=this;
				td.onclick = function(){
					if( confirm("确定删除该版本吗?") )
					{
						that.doTrade( "DELETE", ServAddr+"/api/app/verDel/"+ver.avId, that.onDeleteOK, true, null, null );
					}
				};
			}
		},
		onDeleteOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			this.getVerList( 2 );
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// verMgr.vue?13a2a9e5